
<section class="banner-info">
    <div class="banner-content">
        <h2>Solicitud de Derechos ARCC (REDEC)</h2>
        <p class="intro">
            Si deseas realizar una solicitud de actualización, rectificación, complementación o cancelación de la información de deuda almacenada en el REDEC, puedes enviarla al correo:
        </p>
        <a href="mailto:servicioalcliente@unipay.cl" class="email">servicioalcliente&#64;unipay.cl</a>
        
        <p class="instruction">Para una correcta gestión de tu solicitud, te pedimos incluir la siguiente información:</p>
        
        <ul class="requirements">
            <li>Asunto del correo: <strong>“Derechos ARCC”</strong></li>
            <li>Tipo de derecho que deseas ejercer</li>
            <li>Descripción del dato que consideras erróneo, desactualizado, inexacto o incompleto</li>
            <li>Fundamento de tu solicitud</li>
            <li>Tus datos de contacto: RUT, nombre completo, correo electrónico y teléfono</li>
            <li>Documentación de respaldo, incluyendo el informe de deuda que contiene la información que deseas rectificar</li>
        </ul>

        <div class="pie-arcc">Esto nos permitirá analizar tu caso de forma más rápida y eficiente.</div>
    </div>
</section>